import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useFeatureFlag from 'app/ducks/featureFlags/hooks'
import { timestamp as flagsTimestamp } from 'app/ducks/featureFlags/selectors'
import { useIsUser } from 'app/ducks/auth/hooks'
import { fetchInternalCampaigns } from './actions'
import { INTERNAL_CAMPAIGNS_FLAG, INTERNAL_CAMPAIGN_ROLES } from './constants'
import * as selectors from './selectors'

export const useInternalCampaignsEnabled = () => {
  const isFlagOn = useFeatureFlag(INTERNAL_CAMPAIGNS_FLAG)
  const isAudience = useIsUser(INTERNAL_CAMPAIGN_ROLES)
  return isFlagOn && !!isAudience
}

/**
 * Campaigns for the logged user, loaded on first use. Returns an empty
 * list (and never calls the API) when the feature is off for this user.
 * `flagsLoaded` tells "off" apart from "flags not fetched yet" (they're
 * cleared on every page load and re-fetched after getUserInfo).
 */
export const useInternalCampaigns = () => {
  const dispatch = useDispatch()
  const enabled = useInternalCampaignsEnabled()
  const flagsLoaded = !!useSelector(flagsTimestamp)
  const status = useSelector(selectors.status)
  const campaigns = useSelector(selectors.campaigns)
  const newCount = useSelector(selectors.newCampaignsCount)
  const popupCampaigns = useSelector(selectors.popupCampaigns)

  useEffect(() => {
    if (enabled && status === 'idle') dispatch(fetchInternalCampaigns())
  }, [enabled, status, dispatch])

  if (!enabled)
    return {
      enabled,
      flagsLoaded,
      status: 'idle',
      campaigns: [],
      newCount: 0,
      popupCampaigns: [],
    }
  return { enabled, flagsLoaded, status, campaigns, newCount, popupCampaigns }
}
